import React from 'react'
import Loader from '../common/Loader'

const { createContext, useState } = React

export const FormDependencyLoaderContext = createContext({
  isLoading: false,
  show: () => {
    // do nothing
  },
  hide: () => {
    // do nothing
  },
})

export const FormDependencyLoaderProvider = ({ children }) => {
  const show = () => {
    update((prev) => ({
      ...prev,
      isLoading: true,
    }))
  }
  const hide = () => {
    update((prev) => ({
      ...prev,
      isLoading: false,
    }))
  }

  const [state, update] = useState({
    isLoading: false,
    show,
    hide,
  })
  return (
    <FormDependencyLoaderContext.Provider value={state}>
      {state.isLoading ? <Loader /> : null}
      {children}
    </FormDependencyLoaderContext.Provider>
  )
}

export default FormDependencyLoaderContext
